import React, { useState, useEffect } from "react";
import useSalesReceiptStore from "../store";

export default function CashAccounts() {
  const { cashAccounts, setCashAccounts, creditCardFees } =
    useSalesReceiptStore();
  const initialCashAccount = { account: "", cash_accounts_amount: 0 };
  const [newCashAccount, setNewCashAccount] = useState(initialCashAccount);
  const [editIndex, setEditIndex] = useState(-1);
  const [totalCashAccounts, setTotalCashAccounts] = useState(0);

  useEffect(() => {
    const sum = cashAccounts?.reduce(
      (acc, item) =>
        acc + parseFloat(item?.cash_accounts_amount),
      0
    );
    setTotalCashAccounts(sum);
  }, [cashAccounts]);

  const handleCashAccountChange = (e, index) => {
    const updatedCashAccounts = [...cashAccounts];
    updatedCashAccounts[index].liability = e.target.value;
    setCashAccounts(updatedCashAccounts);
  };

  const handleAmountChange = (e, index) => {
    const updatedCashAccounts = [...cashAccounts];
    updatedCashAccounts[index].cash_accounts_amount = parseFloat(
      e.target.value
    );
    setCashAccounts(updatedCashAccounts);
  };

  const handleAddCashAccount = () => {
    if (editIndex === -1) {
      setCashAccounts([...cashAccounts, newCashAccount]);
    } else {
      const updatedCashAccounts = [...cashAccounts];
      updatedCashAccounts[editIndex] = newCashAccount;
      setCashAccounts(updatedCashAccounts);
      setEditIndex(-1);
    }
    setNewCashAccount(initialCashAccount);
  };

  const handleDeleteCashAccount = (index) => {
    const updatedCashAccounts = [...cashAccounts];
    updatedCashAccounts.splice(index, 1);
    setCashAccounts(updatedCashAccounts);
  };

  if (cashAccounts.length === 0) {
    return null;
  }

  return (
    <div className="mx-3 my-3 border-white rounded shadow-sm p-3">
      <h4>Cash Accounts</h4>
      <div
        className="my-2"
        style={{
          minHeight: "87px",
        }}
      >
        {cashAccounts.map((item, index) => (
          <div key={index} className="d-flex mb-3">
            <label className="mx-1 w-100 form-control">{item?.cash_accounts_name}</label>
            <input
              type="number"
              className="form-control"
              name="cash_accounts_amount"
              value={item?.cash_accounts_amount?parseFloat(item?.cash_accounts_amount?.toFixed(2)):null}
              onChange={(e) => handleAmountChange(e, index)}
              readOnly
              disabled
            />
          </div>
        ))}
      </div>
      <hr className="featurette-divider" />
      <div className="row d-flex justify-content-end align-items-center mt-3">
        <div className="col-md-6 d-flex">
          <h5 className="text-muted">Total Cash Accounts:</h5>
          <p className="fw-bold fs-5">${totalCashAccounts?.toFixed(2)=="NaN"?0:totalCashAccounts?.toFixed(2)}</p>
        </div>
      </div>
      <hr className="featurette-divider" />
      <div
        className="row text-muted p-3 rounded bg-body-tertiary"
      >
        <div className="col-md-6">
          <label htmlFor="fee-cash_accounts_amount" className="form-label">
            CC Fee Amount:
          </label>
          <input
            id="fee-cash_accounts_amount"
            name="fee-cash_accounts_amount"
            type="text"
            className="form-control"
            value={creditCardFees?.amount}
            readOnly
          />
        </div>

        <div className="col-md-6">
          <label htmlFor="fee-cash_accounts_amount" className="form-label">
            Sales Date:
          </label>
          <input
            id="fee-cash_accounts_amount"
            name="fee-cash_accounts_amount"
            type="text"
            className="form-control"
            value={creditCardFees?.sales_date}
            readOnly
          />
        </div>
      </div>
    </div>
  );
}
